/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { Confirm } from "src/refresh/service/constant";
import { ApplicantVO } from "../data/app-vo";
import { Address, Contact, Eligibility, InputData, OrderOfBC, ParentInfo } from "../data/input-data";
import { BaseCreator } from "./BaseCreator";
var show = console.log.bind( console );

export class ApplicantCreator extends BaseCreator {

       private applicant:ApplicantVO;
       private data:InputData;

       constructor() { super();  }
 
       public create(lang:string,isBR:boolean, theData:InputData) : ApplicantVO {

              this.data = theData;
              this.applicant = new ApplicantVO();

              if ( isBR ) this.BRApplicant();
              else        this.BCApplicant();

              this.applicant.language = lang; 

              let contact:Contact = this.data.contact;
              let address:Address = contact.address;

              this.applicant.streetNumber = this.toUpperCase(address.streetNumber);
              this.applicant.streetName   = this.toUpperCase(address.streetName);
              this.applicant.apartmentNumber = this.toUpperCase(address.unit);
              this.applicant.buzzerNumber    = this.toUpperCase(address.buzz);

              this.applicant.city = this.toUpperCase(address.base.city);
              if ( address.chk_international == Confirm.YES ) {
                   if ( address.base.province ) {
                        this.applicant.city += " " + address.base.province;   // city size 150 , so it should be ok
                   }
                   this.applicant.provinceCode = -1;
              }
              else this.applicant.provinceCode = this.toNumber(address.base.province);   // what happend for international?

              this.applicant.countryCode  = this.toNumber(address.base.country);
              this.applicant.otherCountry = this.toUpperCase(address.base.otherCountry);

              if ( this.applicant.otherCountry && 
                   this.applicant.otherCountry.length >= 40 ) 
                   this.applicant.otherCountry = this.applicant.otherCountry.substring(0,40);

              this.applicant.postalCode   = this.toUpperCase(address.postalCode);

              if ( address.chk_international != Confirm.YES ) {
                   if ( address.deliveryMode )  {

                        this.applicant.poBox = this.toUpperCase(address.deliveryAddr);

                        if ( address.deliveryMode != "PO Box") {
                             this.applicant.poBox = address.deliveryMode + " " + this.applicant.poBox;

                             if ( this.applicant.poBox.length > 20 )
                                  this.applicant.poBox = this.applicant.poBox.substring(0,20);
                        }
                   }
              }
              else this.applicant.poBox = this.toUpperCase(address.poBox);  // for international

              //-----------------------------------------------------------------------------
              this.applicant.phoneNumber = contact.phoneNumber();
              this.applicant.phoneExt    = String(contact.phoneExt);

              this.applicant.dayTimePhoneNumber = contact.dayTimeNumber();
              this.applicant.dayTimePhoneExt    = String(contact.daytimeExt);

              //this.applicant.emailAddress = "no.email";

              this.applicant.organizationName = this.toUpperCase(this.data.orderOfBC.organizationForOther);     

              return this.applicant;
       }

       private toNumber(value:string) :number {
               if ( value ) { 
                    let  ret = Number(value);
                    if ( ret >= 0 ) return ret;
               }
               return -1;
       }

       //==========================================================================================
       private BRApplicant() {

            if ( this.setOtherToApplicant() ) return;

            let parent:ParentInfo = this.getCertifyingBirthParent();
            if ( !parent ) 
                  parent = this.getCertifyingParent();
            this.setParentName( parent );
       }

       //---------------------------------------------------------------------------------------
       private getCertifyingBirthParent() : ParentInfo{

                   for ( let i = 0 ; i < this.data.eligibility.listedParentCount; i++ ) {
                         if ( this.data.parents[i].isGiveBirth == Confirm.YES ) {
                              if ( this.data.parents[i].isCertifyingParent == Confirm.YES )
                                   return this.data.parents[i];
                              else return null;     
                         }
                   }
                   return null;
       }

       //---------------------------------------------------------------------------------------
       private getCertifyingParent() : ParentInfo{

                   for ( let i = 0 ; i < this.data.eligibility.listedParentCount; i++ ) {
                              if ( this.data.parents[i].isCertifyingParent == Confirm.YES )
                                   return this.data.parents[i];
                   }
                   return this.data.parents[0];
       }
       //---------------------------------------------------------------------------------------
       private setParentName(parent:ParentInfo) {

               //this.applicant.surname   = this.toUpperCase(parent.name.getSingleOrLast());
               //this.applicant.givenName = this.toUpperCase(parent.name.first);
               this.applicant.surname   = parent.name.getSingleOrLast();
               this.applicant.givenName = parent.name.first;
       }

       private setOtherToApplicant() {

            let  eligibility:Eligibility = this.data.eligibility;

            if ( eligibility.isOtherCertifyingBirth == Confirm.YES ) {

                  if ( eligibility.isOtherSingleName == Confirm.YES ) 
                       this.applicant.surname    = this.toUpperCase(eligibility.otherSingleName);
                  else {
                       this.applicant.givenName  = this.toUpperCase(eligibility.otherFirstName);
                       this.applicant.surname    = this.toUpperCase(eligibility.otherLastName);
                  }
                  return true;
             }

             return false;
       }

       //==========================================================================================
       private BCApplicant() {

            if ( this.setOtherToApplicant() ) return;

            let orderOfBC:OrderOfBC = this.data.orderOfBC;
            let parent:ParentInfo = null;

            if ( orderOfBC.applicantIndex >= 0 && orderOfBC.total > 0 )  
                 parent =  this.data.parents[orderOfBC.applicantIndex];
            else
            if ( this.data.CCB.chk_consent == true ) 
                 parent =  this.data.parents[this.data.CCB.primaryCaregiver];
            /**
            else 
            if ( this.data.SIN.chk_read == true ) {
                 for ( let i = 0; i < this.data.eligibility.listedParentCount; i++ ) {
                       if ( this.data.parentList[i].isSINParent ) {
                            parent = this.data.parentList[i];
                            break;
                       }
                 }
            }
            */     

            if ( parent ==  null ) parent = this.getCertifyingParent();

            this.data.applicantParent = parent;

            this.setParentName(parent);                  
       }
}
